export const Bio = {
  name: "Isuru Wickramasinghe",
  roles: [
    "Full Stack Developer",
    "Mobile Developer",
    "Fivem Server Developer",
    "UI/UX Designer",
    "Graphic Designer",
  ],
  description:
    "I am an experienced designer and developer. I focus on crafting visually striking designs for websites, social media, and more. I have a strong foundation in coding, and I believe in collaboration, working closely with clients to seamlessly align design and technical solutions. Let's team up to turn your creative ideas into remarkable things. Feel free to contact me for work inquiries or collaborations!",
  github: "https://github.com/WICKxDEV",
  resume:
    "https://drive.google.com/file/d/1Dlcu5PgRp2aE6W7MqU4ztRtf199-3400/view",
  linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-wickxdev/",
  twitter: "https://x.com/WICKxDEV",
  insta:
    "https://www.instagram.com/isuru_sheh?igsh=ZXo0MHl0MnFvYTVj&utm_source=qr",
  facebook:
    "https://www.facebook.com/profile.php?id=100090017895401&mibextid=LQQJ4d",
};

export const skills = [
  {
    title: "Front-end",
    skills: [
      {
        name: "HTML",
        image: "https://skillicons.dev/icons?i=html",
      },
      {
        name: "CSS",
        image: "https://skillicons.dev/icons?i=css",
      },
      {
        name: "JavaScript",
        image: "https://skillicons.dev/icons?i=js",
      },
      {
        name: "Bootstrap",
        image: "https://skillicons.dev/icons?i=bootstrap",
      },
      {
        name: "React",
        image: "https://skillicons.dev/icons?i=react",
      },
      {
        name: "Tailwind CSS",
        image: "https://skillicons.dev/icons?i=tailwind",
      },
    ],
  },
  {
    title: "Back-end",
    skills: [
      {
        name: "PHP",
        image: "https://skillicons.dev/icons?i=php",
      },
      {
        name: "Laravel",
        image: "https://skillicons.dev/icons?i=laravel",
      },
      {
        name: "Lua",
        image: "https://skillicons.dev/icons?i=lua",
      },
      {
        name: "Node.js",
        image: "https://skillicons.dev/icons?i=nodejs",
      },
      {
        name: "C",
        image: "https://skillicons.dev/icons?i=c",
      },
      {
        name: "C++",
        image: "https://skillicons.dev/icons?i=cpp",
      },
      {
        name: "Kotlin",
        image: "https://skillicons.dev/icons?i=kotlin",
      },
      {
        name: "Java",
        image: "https://skillicons.dev/icons?i=java",
      },
      {
        name: "Python",
        image: "https://skillicons.dev/icons?i=python",
      },
    ],
  },
  {
    title: "Database",
    skills: [
      {
        name: "MySQL",
        image: "https://skillicons.dev/icons?i=mysql",
      },
      {
        name: "MongoDB",
        image: "https://skillicons.dev/icons?i=mongodb",
      },
      {
        name: "Firebase",
        image: "https://skillicons.dev/icons?i=firebase",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "GitHub",
        image: "https://skillicons.dev/icons?i=github",
      },
      {
        name: "Git",
        image: "https://skillicons.dev/icons?i=git",
      },
      {
        name: "VS Code",
        image: "https://skillicons.dev/icons?i=vscode",
      },
      {
        name: "Visual Studio",
        image: "https://skillicons.dev/icons?i=visualstudio",
      },
      {
        name: "Android Studio",
        image: "https://skillicons.dev/icons?i=androidstudio",
      },
      {
        name: "Figma",
        image: "https://skillicons.dev/icons?i=figma",
      },
      {
        name: "Adobe Xd",
        image: "https://skillicons.dev/icons?i=xd",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/FiveM-Symbol.png?raw=true",
    role: "Fivem Game Server Developer & Web Developer",
    company: "Freelancing",
    date: "March 2020 - Present",
    desc: "As a freelancer, I have specialized in developing FiveM servers, designing branding logos, and creating websites tailored for those servers. I expertise encompasses end-to-end project management, from conceptualization and design to implementation and deployment. I work ensures that clients receive a cohesive and engaging online presence, enhancing their gaming communities and server visibility.",
    skills: [
      "FiveM Server Development",
      "Web Development",
      "Scripting and Coding",
      "Branding and Logo Design",
      "UI/UX Design",
      "Project Management",
      "Graphic Design",
      "Video Editing",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/3D%20Steel%20WE%20Logo.jpg?raw=true",
    role: "System operator and Maintainer",
    company: "Wickramasinghe Enterprises",
    date: "November 2018 - Present",
    desc: "As a System Operator and Maintainer at Wickramasinghe Enterprises, I'm responsible for ensuring the smooth operation and upkeep of the company's IT systems. This includes monitoring system performance, troubleshooting technical issues, performing regular maintenance tasks, and implementing upgrades to enhance system efficiency and security. I play a crucial role in maintaining the reliability and performance of the organization's technological infrastructure.",
    skills: [
      "System Monitoring",
      "Troubleshooting",
      "Maintenance",
      "Technical Support",
      "Documentation",
      "Communication",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/images%20(1).jpeg?raw=true",
    school: "Sri Lanka Institute of Information Technology",
    date: "2022 - 2024",
    grade: "",
    desc: "Embarking on the journey of higher education at SLIATE, I am currently pursuing a Bachelor of HNDIT. The program is equipping me with a comprehensive understanding of cutting-edge technologies and their applications. This academic pursuit is not only broadening my knowledge in the field but is also fostering critical thinking and problem-solving skills. The specialized curriculum provides a solid foundation in various aspects of Information Technology, preparing me for the dynamic challenges of the digital era. I am enthusiastic about leveraging this educational experience to contribute meaningfully to the evolving landscape of IT.",
    degree: "HIGHER NATIONAL DIPLOMA IN INFORMATION TECHNOLOGY",
  },
  {
    id: 1,
    img: "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/images%20(2).jpeg?raw=true",
    school: "Ibbagamuwa Central College",
    date: "2012 - 2020",
    grade: "",
    desc: "During my studies at Ibbagamuwa Central College, I pursued and completed ordinary-level and advanced-level studies in Engineering Technology With ICT. Beyond academics, I actively engaged in extracurricular activities, notably the School Cricket Team. As a member of the School Cricket Team, I developed strong leadership skills, discipline, and a sense of teamwork through rigorous training & practicing.",
    degree: "Advanced Level (Engineering Technology with ICT)",
  },
];

export const projects = [
  {
    id: 1,
    title: "VMS Web Application",
    date: "September 2024 ",
    description:
      " The VMS is designed to automate and streamline the management of vehicles, drivers, and maintenance schedules for businesses. It provides a comprehensive solution for tracking vehicle usage, managing driver assignments, scheduling regular maintenance, and handling hire details efficiently.",
    image:
      "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/WE-VMS-min.PNG?raw=true",
    tags: ["HTML", "CSS", "JavaScript", "PHP", "Hack", "Bootstrap"],
    category: "web app",
    github: "",
    /* webapp: "", */
    member: [
      {
        name: "Isuru Wickramasinghe",
        img: "https://avatars.githubusercontent.com/u/160169165?v=4",
        linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-WICKxDEV/",
        github: "https://github.com/WICKxDEV",
      },
    ],
  },
  {
    id: 2,
    title: "Serendib journeys",
    date: "August 2024",
    description:
      " Serendib Journeys offers all-inclusive tour guidance across Sri Lanka, providing transportation, accommodations, and curated experiences to showcase the country's most captivating destinations.",
    image:
      "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/serendibpages-min.jpg?raw=true",
    tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    category: "web app",
    github: "https://github.com/WICKxDEV/SLIATE-ATI-Kurunegala-Web",
    /* webapp: "", */
    member: [
      {
        name: "Isuru Wickramasinghe",
        img: "https://avatars.githubusercontent.com/u/160169165?v=4",
        linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-WICKxDEV/",
        github: "https://github.com/WICKxDEV",
      },
    ],
  },
  {
    id: 3,
    title: "ATI Kurunegala",
    date: "Jun 2023 - April 2024",
    description:
      " The SRMS is designed to automate and manage the academic results of students in educational institutions. This SRMS outlines the purpose, scope, and functionality of the SRMS, aiming to ensure clarity and alignment among stakeholders on the system's requirements.The SRMS will enable educators and administrators to input, manage, and disseminate students' grades efficiently. Students and parents will access real-time academic results and performance reports through a secure, user-friendly interface.",
    image:
      "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/sliateweb.PNG?raw=true",
    tags: ["HTML", "CSS", "SCSS", "JavaScript", "PHP", "Hack", "Bootstrap"],
    category: "web app",
    github: "https://github.com/WICKxDEV/SLIATE-ATI-Kurunegala-Web",
    /* webapp: "", */
    member: [
      {
        name: "Isuru Wickramasinghe",
        img: "https://avatars.githubusercontent.com/u/160169165?v=4",
        linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-WICKxDEV/",
        github: "https://github.com/WICKxDEV",
      },
    ],
  },
  {
    id: 4,
    title: "Lucky Auto Service",
    date: "Feb 2023 - Oct 2023",
    description:
      "Developed a comprehensive web application tailored for service stations, encompassing a wide range of functionalities to streamline operations and enhance customer experience. The application includes the following key features:Package Management: Efficiently manage and customize service packages to meet diverse customer needs.Appointment Scheduling: Seamlessly handle appointment bookings with an intuitive interface, reducing wait times and improving service delivery.User Login System: Secure user authentication system allowing customers to create accounts, log in, and manage their profiles.Admin Dashboard: Centralized admin dashboard providing real-time insights and control over service station operations, including user management, package customization, and appointment oversight.Alert Generation: Automated alert system for important notifications, ensuring timely updates and reminders for both customers and staff.Messaging System: Integrated messaging functionality for effective communication between customers and the service station team, enhancing customer support and satisfaction.Additional Features: Various other utilities designed to optimize service station workflow, improve user engagement, and maintain high operational standards.This web application not only enhances the operational efficiency of service stations but also significantly improves the overall customer experience through its user-friendly design and robust functionality.",
    image:
      "https://github.com/WICKxDEV/Isuru-Wickramasinghe/blob/main/src/images/luckyAuto.PNG?raw=true",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
      "PHP",
      "Blade",
      "Laravel Framework",
      "MySQL",
    ],
    category: "web app",
    github: "https://github.com/WICKxDEV/Lucky-Auto-Service-Web",
    /* webapp: "", */
    member: [
      {
        name: "Isuru Wickramasinghe",
        img: "https://avatars.githubusercontent.com/u/160169165?v=4",
        linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-WICKxDEV/",
        github: "https://github.com/WICKxDEV",
      },
    ],
  },
  {
    id: 5,
    title: "Transport Management Service",
    date: "Feb 2023 - Jun 2023",
    description:
      "This robust transport management application, developed using Visual Studio with C# and backed by a MySQL database, is designed to streamline and optimize the operations of transport companies. It offers comprehensive features for managing all aspects of company data, including vehicle information, driver details, route planning, and scheduling. The application provides an intuitive interface for easy data entry and retrieval, ensuring efficient data management. Additionally, it can generate detailed records and reports, offering insights and analytics to aid in decision-making and operational improvements. With a focus on accuracy and efficiency, this application is a valuable tool for enhancing the productivity and effectiveness of transport management processes.",
    image:
      "https://github.com/WICKxDEV/TMS-Updated/blob/master/Resources/Capture2.PNG?raw=true",
    tags: ["C#", "html", "MySQL"],
    category: "android app",
    github: "https://github.com/WICKxDEV/TMS-Updated",
    /* webapp: "", */
    member: [
      {
        name: "Isuru Wickramasinghe",
        img: "https://avatars.githubusercontent.com/u/160169165?v=4",
        linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-WICKxDEV/",
        github: "https://github.com/WICKxDEV",
      },
    ],
  },
  {
    id: 6,
    title: "GitHub Activity Bot for Discord",
    date: "May 2024 - Jun 2024",
    description:
      "Developed using JavaScript and the GitHub API, this GitHub activity bot is designed to enhance your Discord server by providing real-time updates and notifications about GitHub repository activities. The bot seamlessly integrates with your Discord server, allowing users to stay informed about commits, pull requests, issues, and other repository events without leaving the platform. It features customizable notification settings, ensuring that users receive relevant updates tailored to their preferences. By bridging the gap between GitHub and Discord, this bot improves collaboration and keeps your development team engaged and informed.",
    image:
      "https://github.com/WICKxDEV/discordbot-JS/blob/main/340761994-95d229ef-7ed4-4ed7-b26a-53c6c9046576.png?raw=true",
    tags: ["JavaScript", "API"],
    category: "BOTS",
    github: "https://github.com/WICKxDEV/discordbot-JS",
    /* webapp: "", */
    member: [
      {
        name: "Isuru Wickramasinghe",
        img: "https://avatars.githubusercontent.com/u/160169165?v=4",
        linkedin: "https://www.linkedin.com/in/isuru-wickramasinghe-WICKxDEV/",
        github: "https://github.com/WICKxDEV",
      },
    ],
  },
];
